import { SVGProps } from 'react';
import React from 'react';
import styled from 'styled-components';

export default function LinesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width="8" height="1" rx="0.5" />
      <Rect y="4" width="8" height="1" rx="0.5" />
      <Rect y="8" width="8" height="1" rx="0.5" />
    </svg>
  );
}

const Rect = styled.rect`
  fill: ${({ theme }) => theme.colors.background};
`;
